<template>
    <component :is="tagName"
        :props="props"
        :tracker="tracker"
        :children="children"
        @edit-tr="$emit('edit-tr', $event)"
    ></component>
</template>

<script>
import I18nGroupMultirow         from "@/components/i18n/I18nGroupMultirow"
import I18nGroupRow              from "@/components/i18n/I18nGroupRow"
import I18nGroupFrame            from "@/components/i18n/I18nGroupFrame"
import I18nGroupAccordion        from "@/components/i18n/I18nGroupAccordion"
//import I18nGroupGroup            from "@/components/i18n/I18nGroupGroup"

export default {
    name: "I18nGroup",
    components: {I18nGroupMultirow, I18nGroupRow, I18nGroupFrame, I18nGroupAccordion},
    props: {
        tracker: Array,
        index: Number,
        children: Array,
        props: Object,
        showLabel: {default: true}
    },
    computed: {
        tagName () {
            return 'i18n-group-' + this.props.valuetype.val.toLowerCase ()
        }
    }
}
</script>
